import React, { createContext, useContext, useState, useEffect } from 'react';
import { COUNTRIES } from '@/data/mockData';

const CountryContext = createContext(null);

export const CountryProvider = ({ children }) => {
  const [country, setCountryState] = useState(() => {
    try {
      const saved = typeof window !== 'undefined' ? localStorage.getItem('balkania_country') : null;
      if (saved) {
        const found = COUNTRIES.find(c => c.code === saved && c.available);
        if (found) return found;
      }
    } catch (e) {}
    return COUNTRIES[0];
  });

  const setCountry = (c) => {
    setCountryState(c);
    try { localStorage.setItem('balkania_country', c.code); } catch (e) {}
  };

  useEffect(() => {
    try { localStorage.setItem('balkania_country', country.code); } catch (e) {}
  }, [country]);

  return <CountryContext.Provider value={{ country, setCountry }}>{children}</CountryContext.Provider>;
};

export const useCountry = () => {
  const ctx = useContext(CountryContext);
  if (!ctx) throw new Error('useCountry must be used within CountryProvider');
  return ctx;
};
